import styles from "./shape-with-color.module.less";
import animations from "../../../animation/animation.module.less";
import { useIntersectionObserver } from "usehooks-ts";

const getSvgForShape = (shape: string, enteredViewPort: boolean) => {
  const animation = enteredViewPort ? animations.scaleDown12to1 : undefined;

  switch (shape) {
    case "shape-4-with-color":
      return (
        <svg
          className={[styles.svg, shape].join(" ")}
          viewBox="0 0 634 640"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={[styles.svgPath, animation].join(" ")}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M292.476 25.75C292.459 42.835 292.013 53.661 291.15 57.922C285.788 84.398 265.379 124.657 243.705 151.513C231.174 167.04 212.352 183.434 196.919 192.265C189.296 196.627 177.508 200.882 168.767 202.427C164.22 203.231 150.375 204.356 138 204.927C113.827 206.044 99.822 208.272 84.566 213.428C17.546 236.079 -11.326 299.765 4.53398 389.963C10.905 426.197 18.41 447.945 85.724 625.25L91.324 640H271.654H451.984L450.334 635.75C448.502 631.029 434.023 599.654 420.222 570.5C403.344 534.846 396.457 513.938 395.352 495C394.242 475.989 400.477 459.498 413.879 445.996C422.391 437.42 431.071 431.324 447.862 422.131C460.583 415.166 470.359 408.75 480 401.041C532.101 359.376 577.797 288.697 604.482 208.5C618.19 167.303 627.02 124.197 631.502 76.589C632.99 60.789 633.618 6.91 632.37 2.25L631.767 0H462.133H292.5L292.476 25.75Z"
          />
        </svg>
      );
    case "shape-5-with-color":
      return (
        <svg
          className={[styles.svg, shape].join(" ")}
          viewBox="0 0 1302 640"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={[styles.svgPath, animation].join(" ")}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M82.295 11.2505C59.677 36.9335 33.548 69.8905 12.25 99.6015L0 116.69V378.345V640H146.621H293.243L288.766 634.75C250.421 589.781 239.117 505.085 255.568 386C262.403 336.521 272.215 299.007 288.044 261.832C320.87 184.742 377.552 123.377 449.924 86.5775C483.053 69.7315 504.151 63.8795 531.684 63.9005C568.827 63.9295 603.318 77.7865 629.68 103.271C648.035 121.016 659.224 139.327 668.058 166.077C676.455 191.504 685.557 206.851 700.534 220.839C724.409 243.135 754.869 254 793.5 254C832.519 254 862.147 244.063 898 218.951C1019.22 134.048 1144.37 65.3895 1276 11.5815C1288.93 6.29846 1300.9 0.506244 1302 0.00024426C1298 0 1067.16 0.109458 697.852 0.0684581L92.203 0.000458032L82.295 11.2505Z"
          />
        </svg>
      );
    case "shape-6-with-color":
      return (
        <svg
          className={[styles.svg, shape].join(" ")}
          viewBox="0 0 1560 640"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={[styles.svgPath, animation].join(" ")}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1552.67 1.08473C1549.92 1.61587 1537.32 3.96579 1524.67 6.30725C1373.92 34.2048 1220.59 80.453 1076.37 141.52C1016.15 167.021 971.12 188.47 907.071 222.159C880.926 235.911 855.463 248.865 850.487 250.948C826.943 260.797 810.617 259.841 798.103 247.88C795.767 245.648 789.761 238.136 784.754 231.188C774.303 216.681 759.915 200.987 748.994 192.184C709.599 160.425 654.658 143.515 574.202 138.382C552.041 136.969 479.403 137.642 455.551 139.481C378.302 145.439 316.041 163.107 248.528 198.226C196.237 225.428 147.675 260.385 97.0109 307.297C78.0708 324.835 34.3329 371.383 15.6818 393.85L0 412.741V526.37V640H113.932H227.864L232.607 630.742C266.644 564.317 317.93 511.043 379.967 477.671C413.099 459.847 434.2 453.656 461.736 453.678C498.883 453.709 533.378 468.37 559.743 495.334C578.06 514.069 589.291 533.489 598.066 561.599C609.45 598.062 624.291 619.007 650.51 635.607L657.448 640H725.36H793.271L802.234 635.103C807.163 632.41 818.936 624.481 828.395 617.484C986.749 500.349 1149.54 413.403 1329.15 350.03C1393.89 327.187 1452.92 310.018 1527.17 292.433L1559.68 284.735L1559.93 142.309C1560.13 28.6606 1559.93 -0.0939359 1558.93 0.000230285C1558.24 0.0647711 1555.42 0.55359 1552.67 1.08473Z"
          />
        </svg>
      );
    default:
      return null;
  }
};

const ShapeWithColor = ({ shape, blockIndex }: { shape: string; blockIndex: number | undefined }) => {
  const shouldAlwaysRenderAnimations = blockIndex === 0;

  // We need to do the SVG enter viewport animation manually by using a callback on parents element whileInView
  // bug here: https://bugs.chromium.org/p/chromium/issues/detail?id=963246
  // From framer documentation: https://www.framer.com/motion/scroll-animations/#scroll-triggered-animations (scroll down a littel bit)
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.25,
    freezeOnceVisible: true,
  });

  const animationClasses = [
    shouldAlwaysRenderAnimations ? animations.fadeIn400 : isIntersecting ? animations.fadeIn400 : "",
    animations.opacity0,
  ].join(" ");

  return (
    <div ref={ref} className={styles.wrapper}>
      <div className={[...animationClasses, styles.shapeWithColorWrapper, shape].join(" ")}>
        {getSvgForShape(shape, shouldAlwaysRenderAnimations || isIntersecting)}
      </div>
    </div>
  );
};

export default ShapeWithColor;
